import angular from 'angular';
import orgTreeSearchDirective from './orgTreeSearchDirective'; 

export default angular
    .module('app.orgTreeSearch', []) 
    .directive('orgTreeSearch',orgTreeSearchDirective)
    .name;


// WEBPACK FOOTER //
// ./src/components/orgTreeSearch/index.js